export default "__VITE_ASSET__BquggwFH__"